import axios from '../../axios/index.js'

export default {
  list(data) {
    return axios.post('bank_statement/list', data)
  },
  store(data) {
    return axios.post('bank_statement', data, {
      headers: { 'Content-Type': 'multipart/form-data' }, processData: false, contentType: false
    })
  },
  delete(data) {
    return axios.delete('bank_statement/delete', {params:data})
  },
  bankList() {
    return axios.post('banks/list')
  },
  getAccountList(data) {
    return axios.get('bank_statement/account_list',{params:data})
  },
  storeAccount(data) {
    return axios.post('bank_statement/storeAccount', data)
  },
  updateAccount(data){
    return axios.post('bank_statement/updateAccount', data)
  },
  updateStatement(data){
    return axios.post('bank_statement/updateBankStatement', data)
  },
  bankAccountList(data){
    return axios.get('bank_statement/bankAccountList',{params:data})
  }
}
